<template>
  <div class="circle" ref="circle"></div>
</template>

<script>
import lottie from 'lottie-web';
import circle from '@/assets/animations/circle.json';

export default {
  name: 'Progress',
  props: {
    steps: Number,
    step: Number,
  },
  mounted() {
    this.animation = lottie.loadAnimation({
      container: this.$refs.circle,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      animationData: circle,
    });
    this.reset();
  },
  beforeDestroy() {
    if (!this.animation) return;

    this.animation.destroy();
  },
  data: () => ({
    animation: null,
    isPlaying: false,
  }),
  methods: {
    reset() {
      if (!this.animation) return;

      this.animation.goToAndStop(0, true);
      this.animation.setSpeed(0.5);
      this.isPlaying = false;
    },
    start() {
      if (!this.animation) return;

      this.animation.playSegments([0, 130], true);
      this.isPlaying = true;
    },
    finish() {
      if (!this.animation) return;

      this.animation.setSpeed(1);
      this.animation.onComplete = () => {
        this.isPlaying = false;
        this.$emit('ended');
      };
      this.animation.playSegments([131, 240]);
    },
  },
  watch: {
    step(nv) {
      if (!this.animation) return;

      if (nv === 0) {
        this.reset();
      } else if (nv === this.steps) {
        this.finish();
      } else if (nv > 0 && !this.isPlaying) {
        this.start();
      }
    },
  },
};
</script>
